var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(Boolean(_vm.values.type === 'multiple'))?_c('NewCertificate',{attrs:{"use-type-certificate":_vm.useTypeCertificate}}):_vm._e(),_vm._v(" "),(Boolean(_vm.values.type === 'single'))?_c('OldCertificate'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }